module.exports = __webpack_public_path__ + "static/media/doclad10.a8916051.pdf";